import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  AdvancedCombobox,
  ModalHeaderWithActions,
} from "@evertrue/et-components";
import {
  Form,
  JourneysFormField,
  JourneysRow,
  JourneysLabel,
  JourneysTextArea,
  JourneysInput,
} from "scripts/style/components/form";
import { getJourneyGroupsForOrg } from "../../utils/api-requests/journeys-requests";

const TYPE_OPTIONS = [
  { label: "Other", value: "OTHER" },
  { label: "Qualification", value: "QUALIFICATION" },
  { label: "Cultivation", value: "CULTIVATION" },
  { label: "Solicitation", value: "SOLICITATION" },
  { label: "Stewardship", value: "STEWARDSHIP" },
];

const JourneysModal = ({
  isOpen,
  onClose,
  existingJourney = {},
  editJourney = () => {},
  createJourney = () => {},
}) => {
  const [editJourneyId, setEditJourneyId] = useState(existingJourney.id);
  const [journeyName, setJourneyName] = useState("");
  const [journeyDescription, setJourneyDescription] = useState("");
  const [selectedJourneyGroup, setSelectedJourneyGroup] = useState({});
  const [selectedType, setSelectedType] = useState({});
  const [journeyGroups, setJourneyGroups] = useState([]);

  const handleSubmit = () => {
    const { value: journeyGroupId = null } = selectedJourneyGroup;
    const { value: journeyType = null } = selectedType;
    const payload = {
      id: editJourneyId,
      name: journeyName,
      objective_description: journeyDescription,
      journey_group_id: journeyGroupId,
      journey_type: journeyType,
    };

    if (editJourneyId) {
      editJourney(payload);
    } else {
      delete payload.id;
      createJourney(payload);
    }
    onClose();
  };

  // prepopulate the form with the existing journey details
  useEffect(() => {
    const getAndSetData = async () => {
      const journeyGroupsFromApi = await getJourneyGroupsForOrg();

      const journeyGroupOptions = journeyGroupsFromApi.map((group) => ({
        label: group.name,
        value: group.id,
      }));

      if (existingJourney.id) {
        const {
          id,
          name = "",
          objective_description = "",
          journey_group_id = "",
          journey_type = "",
        } = existingJourney;

        const selected = journeyGroupOptions.find(
          (group) => group.value === journey_group_id
        );

        const selectedType = TYPE_OPTIONS.find(
          (type) => type.value === journey_type
        );

        setSelectedJourneyGroup(selected || {});
        setEditJourneyId(id);
        setJourneyName(name);
        setJourneyDescription(objective_description || "");
        setSelectedType(selectedType || {});
      }

      setJourneyGroups(journeyGroupOptions);
    };

    getAndSetData();
  }, [existingJourney]);

  return (
    <Modal isOpen={isOpen} closeModal={onClose}>
      <ModalHeaderWithActions
        title={editJourneyId ? "Edit Cadence Details" : "Create Cadence"}
        submitLabel={editJourneyId ? "Update" : "Create"}
        closeModal={onClose}
        onSubmit={handleSubmit}
      />
      <ModalBody scrollable={false}>
        <Form>
          <JourneysRow>
            <JourneysFormField>
              <JourneysLabel htmlFor="display-name">Cadence Name</JourneysLabel>
              <JourneysInput
                type="text"
                onChange={({ target: { value } }) => setJourneyName(value)}
                name="name"
                value={journeyName}
              />
            </JourneysFormField>
            <JourneysFormField>
              <JourneysLabel htmlFor="field-type">Description</JourneysLabel>
              <JourneysTextArea
                onChange={({ target: { value } }) =>
                  setJourneyDescription(value)
                }
                id="cadence-description"
                value={journeyDescription}
              />
            </JourneysFormField>
            <JourneysFormField>
              <JourneysLabel htmlFor="field-type">Cadence Groups</JourneysLabel>
              <AdvancedCombobox
                placeholder="Select Cadence Group..."
                options={journeyGroups}
                value={selectedJourneyGroup}
                onChange={(v) => setSelectedJourneyGroup(v)}
              />
            </JourneysFormField>
            <JourneysFormField>
              <JourneysLabel htmlFor="field-type">Cadence Type</JourneysLabel>
              <AdvancedCombobox
                placeholder="Select Cadence Type..."
                options={TYPE_OPTIONS}
                value={selectedType}
                onChange={(v) => setSelectedType(v)}
              />
            </JourneysFormField>
          </JourneysRow>
        </Form>
      </ModalBody>
    </Modal>
  );
};

JourneysModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  existingJourney: PropTypes.object,
  editJourney: PropTypes.func,
  createJourney: PropTypes.func,
};

JourneysModal.defaultProps = {
  existingJourney: {},
  editJourney: () => {},
  createJourney: () => {},
};

JourneysModal.defaultProps = {
  editDetails: {},
};

export default JourneysModal;
